module.exports = __webpack_public_path__ + "static/media/debug.0df79069.log";